import { FC, ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { Fade } from "@mui/material";
import { ModalRow } from "components/Rows";
import {
  ModalButton,
  CloseModalButton,
  BackModalButton,
} from "components/Buttons";
import { CardImage } from "components";
import {
  ModalContent,
  StatusDecorative,
  InfoColumn,
  ModalHeading,
} from "../styled";
import { InfoRows } from "components/Modals/styled";
import type { AvailableTradeOptions } from "helpers/types";

interface ConfirmPurchaseStepProps {
  cardImage: string;
  brandName: string;
  chosenCurrency: string;
  onClose: () => void;
  onSubmit: () => void;
  currencyValue: string;
  currency: AvailableTradeOptions | null;
  isCrypto?: boolean;
  TransactionInfos: ReactNode;
  giftCode?: string;
  phoneNumber?: string;
  embossName?: string;
  chosenDeliveryAddressName?: string;
  cardWithDiscountGift?: boolean;
  cardIsFree?: boolean;
}

const ConfirmPurchaseStep: FC<ConfirmPurchaseStepProps> = ({
  onClose,
  currencyValue,
  currency,
  cardImage,
  brandName,
  chosenCurrency,
  onSubmit,
  isCrypto,
  TransactionInfos,
  giftCode,
  phoneNumber,
  embossName,
  chosenDeliveryAddressName,
  cardWithDiscountGift,
  cardIsFree,
}) => {
  const { t } = useTranslation();

  return (
    <Fade in timeout={500}>
      <ModalContent>
        <ModalHeading $centered>
          {t(isCrypto ? "CRYPTO_CARD_REVIEW" : "GIFT_CARD_REVIEW")}
        </ModalHeading>
        <CloseModalButton onClose={onClose} />
        <BackModalButton onBack={onClose} />

        <StatusDecorative $noIcon>
          <CardImage src={cardImage} alt={brandName} />
        </StatusDecorative>

        <InfoColumn>
          <InfoRows>
            <ModalRow
              keyText={t(
                cardWithDiscountGift || cardIsFree
                  ? "ORIGINAL_PRICE"
                  : "CARD_PRICE"
              )}
              value={`${currencyValue} ${chosenCurrency}`}
            />
            {giftCode && <ModalRow keyText={t("GIFT_CODE")} value={giftCode} />}
            {embossName && (
              <ModalRow keyText={t("CARD_HOLDER")} value={embossName} />
            )}
            {phoneNumber && (
              <ModalRow keyText={t("PHONE_NUMBER")} value={phoneNumber} />
            )}
            {chosenDeliveryAddressName && (
              <ModalRow
                keyText={t("ADDRESS")}
                value={chosenDeliveryAddressName}
              />
            )}
            {currency && (
              <ModalRow
                keyText={t("ASSET_OR_PAYMENT_METHOD")}
                value={currency}
              />
            )}
          </InfoRows>
          {TransactionInfos}

          <ModalButton onClick={onSubmit}>{t("CONFIRM")}</ModalButton>
        </InfoColumn>
      </ModalContent>
    </Fade>
  );
};

export default ConfirmPurchaseStep;
